import api from '@/api/app'
const square = {
  square: {
    viewInfo: {
      obj: {
        tabs: [
          {
            id: 111,
            key: 0,
            name: '全部推荐',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '我的收藏',
            type: 'text'
          }
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      spaceTypes: (obj) => {
        return new Promise((resolve) => {
          const obj1 = {}
          if (obj && obj.grade != 0) {
            obj1.category_id = obj.grade
          }
          api.square.retrieve.conditions(obj1).then((res) => {
            if (res.data.length) {
              res.data.map(item => {
                item.children.unshift({
                  id: 0,
                  name: `${item.title}`
                })
              })
            }
            resolve(res.data)
          })
        })
      },
      spaces: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.data(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'true'
                item.dtoId = item.id
              })
            }
            resolve(res.data)
          })
        })
      },
      spaces1: (obj) => {
        return new Promise((resolve) => {
          api.mine.retrieve.collect(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'true'
                item.dtoId = item.collection_id
              })
            }
            resolve(res.data.data)
          })
        })
      },
      mock: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.mock(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'false'
              })
            }
            resolve(res.data.data)
          })
        })
      }
    }
  },
  space: {
    viewInfo: {
      obj: {
        btns: [
          {
            label: '',
            model: 'comment',
            type: 'img',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '收藏',
            model: 'evaluate',
            type: 'img',
            status: 0
          },
          {
            label: '分享',
            model: 'share',
            type: 'img',
            status: 0
          },
          {
            label: '转存',
            model: 'unload',
            type: 'img',
            status: 0
          },
          {
            label: '举报',
            model: 'inform',
            type: 'img',
            status: 0
          }
        ],
        tabs: [
          {
            id: 1,
            key: 0,
            name: '详情介绍',
            type: 'text'
          },
          {
            id: 2,
            key: 1,
            name: '建设指南',
            type: 'text'
          },
          {
            id: 3,
            key: 2,
            name: '装备清单',
            type: 'text'
          },
          {
            id: 4,
            key: 3,
            name: '施工图',
            type: 'text'
          },
          {
            id: 5,
            key: 4,
            name: '应用标准',
            type: 'text'
          },
          {
            id: 6,
            key: 5,
            name: '方案咨询',
            type: 'text'
          }
        ],
        table1: [
          {
            type: 'text',
            model: 'name',
            label: '清单名',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'category_name',
            label: '学科名字',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'description',
            label: '清单描述',
            width: '',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ],
        table2: [
          {
            type: 'text',
            model: 'serialNum',
            label: '序号',
            width: '75',
            align: 'center'
          },
          {
            type: 'text',
            model: 'number',
            label: '标准编号',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'article_name',
            label: '标准名称',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'status_str',
            label: '状态',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'type_str',
            label: '应用场景',
            width: '150',
            align: 'center'
          },
          {
            type: 'text',
            model: 'category_id_str',
            label: '标准类型',
            width: '150',
            align: 'center'
          },
          {
            type: 'text',
            model: 'fabu_time',
            label: '发布时间',
            width: '125',
            align: 'center'
          },
          {
            type: 'text',
            model: 'ss_time',
            label: '实施日期',
            width: '125',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ]
      },
      data: {
        data1: [
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 1,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 1,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品3',
            img: 'equip1',
            type: 2,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 2,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 3,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品3',
            img: 'equip1',
            type: 3,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 4,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 4,
            collectNum: '101'
          }
        ],
        data2: {
          imgs: [1, 2],
          total: 101
        }
      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      types: () => {
        return new Promise((resolve) => {
          api.square.retrieve.conditions().then((res) => {
            if (res.data.length) {
              res.data.map((item, index) => {
                item.default = `${index}-0`
                item.children.unshift({
                  id: 0,
                  name: `${item.title}`
                })
              })
            }
            resolve(res.data)
          })
        })
      },
      data: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.data(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'true'
              })
            }
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.dto(obj).then((res) => {
            if (res.data.length) {
              res.data[0].share = null
              res.data[0].show = res.data[0].look_num
              res.data[0].imgList = []
              if (res.data[0].pic_urls.length) {
                res.data[0].pic_urls.map((item, index) => {
                  res.data[0].imgList.push({
                    id: index,
                    cover_img: item
                  })
                })
              }
            }
            resolve(res.data[0])
          })
        })
      },
      url: (obj) => {
        return new Promise((resolve) => {
          api.square.update.dto(obj).then((res) => {
            resolve(res.data.url)
          })
        })
      },
      proList: (obj) => {
        return new Promise((resolve) => {
          api.proList.retrieve.data(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      about1: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.about1(obj).then((res) => {
            if (res.data.data && res.data.data.length) {
              res.data.data.map((item, index) => {
                item.serialNum = index + 1
                item.name = item.article_name
                item.num = item.look_num
              })
            }
            resolve(res.data.data)
          })
        })
      },
      wenku: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.wenku(obj).then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  }
}
export default square
